import { Enrolments } from 'services/resources';
import { TelematicsAction, ActionTypes } from './actions';
import {
  DataSourcesRecordFactory,
  EnrolmentRecordFactory,
  EnrolmentsRecordFactory,
  TelematicsStateFactory,
} from './factories';

const initialState = TelematicsStateFactory();

function telematicsReducer(state = initialState, action: TelematicsAction) {
  switch (action.type) {
    case ActionTypes.SET_DATASOURCES_LOADING:
      return state.setIn(['datasources', 'loading'], true);
    case ActionTypes.SET_ENROLMENTS_LOADING:
      return state.setIn(['enrolments', 'loading'], true);
    case ActionTypes.GET_DATASOURCES_SUCCESS: {
      return state
        .setIn(['datasources', 'loading'], false)
        .setIn(['datasources', 'values'], DataSourcesRecordFactory(action.payload.datasources));
    }
    case ActionTypes.GET_ENROLMENTS_SUCCESS: {
      return state
        .setIn(['enrolments', 'loading'], false)
        .setIn(['enrolments', 'values'], EnrolmentsRecordFactory(action.payload.enrolments));
    }
    case ActionTypes.CREATE_ENROLMENT_SUCCESS: {
      return state
        .setIn(['enrolments', 'loading'], false)
        .mergeIn(['enrolments', 'values'], [EnrolmentRecordFactory(action.payload.enrolment)]);
    }
    case ActionTypes.DELETE_ENROLMENT_SUCCESS: {
      const values = state.getIn(['enrolments', 'values']) as unknown as Enrolments;

      const updatedValues = values.filter((value) => {
        return value.id !== action.payload.enrolmentId;
      });
      return state.setIn(['enrolments', 'loading'], false).setIn(['enrolments', 'values'], updatedValues);
    }
    case ActionTypes.UPDATE_ENROLMENT_SUCCESS: {
      const values = state.getIn(['enrolments', 'values']) as unknown as Enrolments;

      const updatedValues = values.map((value) => {
        if (value.id === action.payload.enrolment.id) {
          return EnrolmentRecordFactory(action.payload.enrolment);
        }
        return value;
      });

      return state.setIn(['enrolments', 'loading'], false).setIn(['enrolments', 'values'], updatedValues);
    }
    case ActionTypes.GET_DATASOURCES_FAIL: {
      return state.setIn(['datasources', 'loading'], false).setIn(['datasources', 'error'], action.payload.error);
    }
    case ActionTypes.DELETE_ENROLMENT_FAIL:
    case ActionTypes.UPDATE_ENROLMENT_FAIL:
    case ActionTypes.GET_ENROLMENTS_FAIL:
    case ActionTypes.CREATE_ENROLMENT_FAIL: {
      return state.setIn(['enrolments', 'loading'], false).setIn(['enrolments', 'error'], action.payload.error);
    }

    default:
      return state;
  }
}

export default telematicsReducer;
